import { ArbeitszeitkontoStundenlohnType } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Arbeitszeitkonto/ArbeitszeitkontoStundenlohn';
import { Sollstunden } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/Sollstunden/Sollstunden';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';

export function Arbeitszeitkonto() {
  const form = useAnlageassistentFormContext();
  return (
    <form.Subscribe
      selector={(state) => ({
        bezahlart: state.values.bezahlung.bezahlungsart.art,
      })}>
      {({ bezahlart }) => {
        if (bezahlart === 'fixgehalt') return <Sollstunden />;
        if (bezahlart === 'stunden') return <ArbeitszeitkontoStundenlohnType />;
        return null;
      }}
    </form.Subscribe>
  );
}
